export let state = {
    devicesManagement: {
        devicesFilters: {
            name: null,
            organization: null,
            fleet: null,
            deviceModelId: null,
            deviceProtocolId: null,
            simCard: null,
            vehicle: null,
            enabled: null,
            neverReporter: null
        }
    },
    fleetManagement: {
        fleetFilters: {
            organization: null,
            fleet: null,
            users: null
        }
    },
    userManagement: {
        userFilters: {
            userName: null,
            email: null,
            firstName: null,
            lastName: null,
            organizations: null,
            fleets: null
        }
    },
    driverManagement: {
        driverFilters: {
            name: null,
            phoneNumber: null,
            fleets: null,
            user: null,
            organizations: null
        }
    },
    organizationsManagement: {
        organizationsFilters: {
            name: null,
            email: null,
            phone: null,
            users: null
        }
    }
}
